import React, { useState } from "react";
import Nav from "./Navigation.js";

const puzzlesData = [
  {
    id: 16,
    name: "Align The Mirrors",
    imagePath: "AlignMirror.PNG",
    locations: ["Jungle"],
  },
  {
    id: 3,
    name: "Follow Light",
    imagePath: "FollowLightV3.PNG",
    locations: [
      "Bamboo Forest",
      "Corn Field",
      "Crypt",
      "Forest",
      "Kept Hedges",
      "Manor",
      "Sewers",
      "Snowy Hedges",
      "Unkept Hedges",
    ],
  },
  {
    id: 6,
    name: "Lever Puzzle",
    imagePath: "LeverPuzzle.PNG",
    locations: ["Crypts", "Unkept Hedges", "Kept Hedges"],
  },
  {
    id: 7,
    name: "Lights Out",
    imagePath: "LightsOut.PNG",
    locations: [
      "Bamboo Forest",
      "Corn Field",
      "Forest",
      "Kept Hedges",
      "Manor",
      "Unkept Hedges",
    ],
  },
  { id: 8, name: "Memory", imagePath: "Memory.PNG", locations: ["Crypt"] },
  {
    id: 12,
    name: "Pipes",
    imagePath: "SewerPuzzle.PNG",
    locations: ["Sewers"],
  },
  {
    id: 1,
    name: "Rush Hour",
    imagePath: "CheckGameName.PNG",
    locations: ["Trenches"],
  },
  {
    id: 10,
    name: "Sequence Cages",
    imagePath: "SequenceCages.PNG",
    locations: ["Corn Field", "Crypt", "Kept Hedges", "Snowy Hedges", "Forest"],
  },
  {
    id: 11,
    name: "Sequence Fire",
    imagePath: "SequenceFire.PNG",
    locations: ["Bamboo Forest"],
  },
  {
    id: 13,
    name: "Shrine",
    imagePath: "Shrine.PNG",
    locations: ["Bamboo Forest"],
  },
  { id: 9, name: "Simon", imagePath: "Simon.PNG", locations: ["Manor"] },
  {
    id: 14,
    name: "Slider Tile Game",
    imagePath: "SliderTile.PNG",
    locations: ["Fog City"],
  },
  {
    id: 15,
    name: "Water Puzzle",
    imagePath: "WaterPuzzle2.PNG",
    locations: ["Dead Forest"],
  },

  // Add more images here if needed...
];

const Puzzle = ({ puzzlesData }) => {
  const [modalImageUrl, setModalImageUrl] = useState(null);
  const [visibleMaps, setVisibleMaps] = useState({}); // State to track visible maps for each puzzle

  const openImageInModal = (imageUrl) => {
    setModalImageUrl(imageUrl);
  };

  const closeModal = () => {
    setModalImageUrl(null);
  };

  const toggleMaps = (id) => {
    setVisibleMaps((prevState) => ({
      ...prevState,
      [id]: !prevState[id] || false,
    }));
  };

  const renderItem = (puzzle) => (
    <div key={puzzle.name}>
      <img
        className="object-scale-down h-48 cursor-pointer"
        src={require(`../imagespuzzle/${puzzle.imagePath}`)}
        alt={puzzle.name}
        onClick={() =>
          openImageInModal(require(`../imagespuzzle/${puzzle.imagePath}`))
        }
      />
      <div>{puzzle.name}</div>
      <div>
        <button
          className="border rounded-lg pl-1 pr-1"
          onClick={() => toggleMaps(puzzle.id)}
        >
          Info
        </button>
      </div>
      {visibleMaps[puzzle.id] && (
  <div className="mt-3 p-3 bg-gray-800 rounded-lg shadow-md text-sm text-gray-200">
    <div className="mb-2">
      <span className="font-semibold text-green-400">Maps:</span>
    </div>
    <div className="ml-3 space-y-1">
      {puzzle.locations.map((location, index) => (
        <div key={index}>• {location}</div>
      ))}
    </div>
  </div>
)}

    </div>
  );

  const renderModal = () => {
    if (!modalImageUrl) return null;

    return (
      <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
        <div className="relative max-w-lg w-full mx-4">
          <img
            src={modalImageUrl}
            alt="Full Size Image"
            className="w-full h-auto rounded-lg"
          />
          <button
            onClick={closeModal}
            className="absolute top-2 right-2 p-2 text-white bg-red-500 rounded-full hover:bg-red-600 shadow-lg"
          >
            ✕
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="text-white">
      <Nav />
      {renderModal()}
      <div className="items-center grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
        {puzzlesData.map((puzzle) => (
          <div key={puzzle.id}>{renderItem(puzzle)}</div>
        ))}
      </div>
    </div>
  );
};

export default function PuzzlePage() {
  return <Puzzle puzzlesData={puzzlesData} />;
}
